<template>
    <div class="on-demand-wrapper">
        <h1 class="main-title individual grid-container">Ross on Demand</h1> 
        <div class="show-container brain-dump" v-if="featured">
            <div class="grid-container grid-100">
                <div class="grid-100 grid-parent buy-all">
                    <a target="_blank" href="https://vimeo.com/ondemand/rossnoble" v-if="featured">
                        <div class="buy-cta all white">
                            <span class="price">All Videos</span>
                        </div>
                    </a>
                </div>
                <div class="grid-100 grid-parent" :key="featured.video_url" v-if="featured">
                    <div class="video-item grid-100 grid-parent">
                        <div class="video-header grid-100 grid-parent">
                            <div class="video">
                                <iframe id="main-video" :src="featured.video_url" width="640" height="352" frameborder="0" webkitallowfullscreen
                                mozallowfullscreen allowfullscreen></iframe>
                            </div>
                        </div>
                        <h4>{{ featured.title.rendered }}</h4>
                    </div>
                </div>
                <div
                    v-for="(video, index) in notFeatured"
                    :key="video.video_url"
                    class="grid-48 grid-parent"
                    :class="{
                        'margin-left-4': index % 2 !== 0
                    }"
                >
                    <div class="video-item grid-100 grid-parent">
                        <div class="video-header grid-100 grid-parent">
                            <div class="video">
                                <iframe id="main-video" :src="video.video_url" width="640" height="352" frameborder="0" webkitallowfullscreen
                                mozallowfullscreen allowfullscreen></iframe>
                            </div>
                        </div>
                        <h4>{{ video.title.rendered }}</h4>
                        <a target="_blank" :href="video.link">
                            <div class="buy-cta white">
                            <span class="price">{{ video.price }}</span>
                            </div>
                        </a>
                        <a target="_blank" :href="tourData.all_video_link">
                            <div class="buy-cta all white">
                            <span class="price">All Videos</span>
                            </div>
                        </a>
                    </div>
                </div>
                <original-content v-if="videos.length > 0"></original-content>
            </div>
        </div>
  </div>
</template>

<script>
import { apiRequest } from "../services";

import OriginalContent from "./OnDemand/OriginalContent";

export default {
    name: "test",
    components: {
        OriginalContent,
    },
    data() {
        return {
            videos: [],
            tourData: []
        };
    },
    computed: {
        featured() {
            return this.videos.find(video => video.featured_video === "1");
        },
        notFeatured() {
            return this.videos.filter(video => video.featured_video !== "1");
        },
    },
    mounted() {
        window.scrollTo(0, 0);
        if (this.$route.params.autoplay) {
            setTimeout(function() {
                window.scrollTo(
                    0,
                    document
                        .getElementById("main-video")
                        .getBoundingClientRect().top
                );
                document.getElementById("main-video").src += "?autoplay=1";
            }, 100);
        }
        apiRequest("on-demand-video").then(this.receivedData);
        apiRequest("tour").then(this.receivedTourData);
    },
    methods: {
        receivedData(data) {
            this.videos = data.reverse();
        },
        receivedTourData(data) {
            this.tourData = data[0];
        },
    },
};
</script>

// Add "scoped" attribute to limit CSS to this component only
<style scoped>
h1,
h2 {
    font-weight: normal;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// OnDemand.vue?7b5daca1